<template>
  <div class="app-main-content">
    <div class="tabs-container" style="position: relative">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane label="Thailand" name="thailand" :lazy="true">
          <thailand-info
            :action="action"
            :thailand2="thailand2"
            :form="thailandForm"
            :container="thailandContainer"
            :job="job"
            :txt-carrier-sc-ac="txtCarrierScAc"
            :cooperate-edit="cooperateEdit"
            @syncThailandInfo="syncThailandInfo"
            @synchroThailandClickHandler="btnSynchroThailandClickHandler"
            @removeCargoDoc="onRemoveThailandCargoDoc"
          />
        </el-tab-pane>
      </el-tabs>
      <div v-show="cooperateEdit" style="position: absolute; left: 320px;">
        <template v-if="activeTabName === 'thailand'">
          <el-button :disabled="thailandEdit" type="primary" style="margin-left: 108px" @click="sendInThailand">Send</el-button>
        </template>
      </div>
    </div>
    <!-- 泰国舱单导出弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="thailandExportDialog.visible"
      :title="thailandExportDialog.showReminder ? 'Reminder' : 'Preview Message'"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div v-if="thailandExportDialog.showReminder" style="display: flex;">
        <div style="display: flex;align-items: center;">
          <i class="el-icon-warning" style="color: #E6A23C;font-size: 20px;" />
        </div>
        <div style="flex-grow: 1;">
          <div style="padding-left: 5px;line-height: 20px;">These fields may have issues</div>
          <cargo-rich-textarea
            v-model="thailandExportDialog.reminderContent"
            :text-chars="0"
            :warning-count="-1"
            style="height: 480px"
          />
        </div>
      </div>
      <cargo-rich-textarea
        v-if="!thailandExportDialog.showReminder"
        v-model="thailandExportDialog.content"
        :text-chars="0"
        :warning-count="-1"
        style="height: 500px"
      />
      <span v-if="thailandExportDialog.showReminder" slot="footer">
        <el-button type="primary" @click="thailandExportDialog.showReminder = false">Continue</el-button>
      </span>
      <div v-if="!thailandExportDialog.showReminder" slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="doExportThailand">Export Current Page</el-button>
        <el-button @click="thailandExportDialog.visible = false">{{ 'Close' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { AfrAddress } from '@/class/model/booking/AfrAddress'
import { EDIContainer } from '@/class/model/booking/EDIContainer'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { getObjectByCache } from '@/utils/basicDataCache'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridAdvanceTextEditor from '@/components/Cargo/Common/CargoAgGridAdvanceTextEditor/index'
import ThailandInfo from '@/views/cargo/v0/SeaExport/components/booking/ams/thailandInfo.vue'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import { loadLclJobSeaCargoDocList } from '@/api/SeaImport/seaImportJob'
import sendThailand from '@/views/cargo/v0/SeaExport/components/booking/ams/sendThailand.js'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'TabImportManifest',
  components: { ThailandInfo, CargoRichTextarea },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeTabName: 'thailand',
      job: {},
      thailandForm: new SeaImCargoDoc().fillDefaultValue().getData(),
      thailandCargoDocs: [],
      txtCarrierScAc: '',
      thailand2: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          },
          onCellFocused: event => {
            const nodes = event.api.rowModel.rowsToDisplay
            this.thailand2.selectedNode = nodes[event.rowIndex] || null
            let data = null
            if (this.thailand2.selectedNode) {
              data = this.thailand2.selectedNode.data
            } else {
              data = new SeaImCargoDoc().fillDefaultValue().getData()
              data.docType = CargoDocConsts.THAILAND
            }
            this.onThailandSelectionChange(event, data)
          },
          onSortChanged: event => {
            if (this.thailand2.selectedNode) {
              event.api.setFocusedCell(this.thailand2.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
            }
          }
        },
        rowData: [],
        gridApi: null,
        selectedNode: null
      },
      thailandContainer: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          rowHeight: 32,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          },
          singleClickEdit: true,
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridCommonTextareaEditor,
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceTextEditor
          }
        },
        rowData: [],
        gridApi: null
      },
      lclSlaveJobMap: new Map(),
      slaveHbls: [],
      addressFields: ['Line1', 'Line2', 'Line3', 'Line4', 'Line5', 'Country', 'Province', 'City', 'Postalcode', 'Tel', 'Fax'],
      thailandExportDialog: {
        visible: false,
        showReminder: false,
        reminderContent: '',
        content: ''
      }
    }
  },
  computed: {
    thailandEdit() {
      return this.cooperateEdit && this.action !== 'look'
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', row.carrierId)
      this.txtCarrierScAc = company ? company.scac : ''
      if (!isRefresh) {
        return
      }
      this.job = row
      this.activeTabName = 'thailand'
      await this.changeJob()
    },
    async changeJob() {
      const cargoDocList = await new SeaImportJob(this.job).getSeaCargoDoc()
      const thailandCargoDocs = []
      if (cargoDocList && cargoDocList.length > 0) {
        for (const doc of cargoDocList) {
          if (doc.docType === CargoDocConsts.THAILAND) {
            thailandCargoDocs.push(doc)
          }
        }
      }
      this.lclSlaveJobMap = new Map()
      this.slaveHbls = []
      if (this.job.lclSlaves && this.job.lclSlaves.length > 0) {
        for (const lclSlave of this.job.lclSlaves) {
          this.lclSlaveJobMap.set(lclSlave.uuid, lclSlave)
        }
        await loadLclJobSeaCargoDocList([...this.lclSlaveJobMap.keys()]).then(resp => {
          this.slaveHbls = resp.data || []
          this.slaveHbls = this.slaveHbls.filter(item => item.docType === CargoDocConsts.HBL && item.hblNbr2)
        })
      }
      for (const cargoDoc of thailandCargoDocs) {
        const hbl = this.slaveHbls.find(p => p.hblNbr2 === cargoDoc.hblNbr2)
        if (hbl) {
          const lclSlave = this.lclSlaveJobMap.get(hbl.jobUuid)
          cargoDoc.jobNo = lclSlave ? lclSlave.jobNo : ''
        } else {
          cargoDoc.jobNo = this.job.jobNo
        }
      }
      this.thailandCargoDocs = thailandCargoDocs
      this.thailand2.rowData = [...this.thailandCargoDocs]
      if (this.thailand2.rowData.length > 0) {
        setTimeout(() => {
          this.thailand2.gridApi.setFocusedCell(0, this.thailand2.gridApi.columnController.getAllDisplayedColumns()[0])
        }, 100)
      } else {
        this.thailandForm = new SeaImCargoDoc().fillDefaultValue().getData()
        this.thailandForm.docType = CargoDocConsts.THAILAND
        this.thailandContainer.rowData = []
      }
    },
    getSubmitData() {
      for (const item of this.thailandCargoDocs) {
        if (!item.hblNbr2) {
          throw new TabError(this.$t('Message.HAWBAfrCannotBeNull'), 'tabImportManifest')
        } else if (!this.checkHblNbr2(item)) {
          throw new TabError(this.$t('Message.HAWBAfrCannotBeRepeated'), 'tabImportManifest')
        }
      }
      this.executeTask()
      return {
        seaCargoDoc: this.thailandCargoDocs
      }
    },
    checkHblNbr2(cargoDoc) {
      let notRepeat = true
      let count = 0
      for (const doc of this.thailandCargoDocs) {
        if (doc !== cargoDoc && doc.hblNbr2 === cargoDoc.hblNbr2) {
          count += 1
          if (count > 1) {
            notRepeat = false
            break
          }
        }
      }
      return notRepeat
    },
    executeTask() {
      const thailandAfrAddress = this.thailandForm.afrAddress[0]
      if (thailandAfrAddress) {
        this.syncAfrAddress('shipper', thailandAfrAddress, DocCommon.THAILAND_History)
        this.syncAfrAddress('consignee', thailandAfrAddress, DocCommon.THAILAND_History)
        this.syncAfrAddress('notify', thailandAfrAddress, DocCommon.THAILAND_History)
        this.syncAfrAddress('shipper', thailandAfrAddress, this.thailandForm)
        this.syncAfrAddress('consignee', thailandAfrAddress, this.thailandForm)
        this.syncAfrAddress('notify', thailandAfrAddress, this.thailandForm)
        this.syncAfrAddress('alsonotify', thailandAfrAddress, DocCommon.THAILAND_History)
      }
      DocCommon.THAILAND_History.mark = this.thailandForm.mark
    },
    syncAfrAddress(type, source, target) {
      for (const key of this.addressFields) {
        target[type + key] = source[type + key] || ''
      }
    },
    async onThailandSelectionChange(event, data) {
      if (data === this.thailandForm) {
        return
      }
      const form = this.thailand2.rowData.find(p => p === this.thailandForm)
      if (form) {
        let isPass = true
        if (!form.hblNbr2) {
          this.$message.info(this.$t('Message.HAWBAfrCannotBeNull'))
          isPass = false
        } else if (!this.checkHblNbr2(form)) {
          this.$message.info(this.$t('Message.HAWBAfrCannotBeRepeated'))
          isPass = false
        }
        if (!isPass) {
          const nodes = event.api.rowModel.rowsToDisplay
          for (const node of nodes) {
            if (node.data === this.thailandForm) {
              event.api.setFocusedCell(node.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
              break
            }
          }
          return
        }
      }
      const cargoDoc = this.thailand2.rowData.find(p => p === data)
      if (cargoDoc) {
        this.thailandContainer.rowData = await new SeaImCargoDoc(cargoDoc).getEdiContainer()
        if (cargoDoc.uuid) {
          // 查询反恐舱单地址
          await new SeaImCargoDoc(cargoDoc).getAfrAddress().then(data => {
            if (!data[0]) {
              cargoDoc.afrAddress = []
              const afrAddress = new AfrAddress().fillDefaultValue().getData()
              afrAddress.cargoDocUuid = cargoDoc.uuid
              cargoDoc.afrAddress.push(afrAddress)
            }
          })
        }
        cargoDoc.isfPassenger = []
      } else {
        this.thailandContainer.rowData = this.thailandContainer.rowData || []
      }
      this.thailandForm = data
    },
    syncThailandInfo(field) {
      if (!field) {
        return
      }
      for (const doc of this.thailandCargoDocs) {
        doc[field] = this.thailandForm[field]
      }
    },
    async btnSynchroThailandClickHandler() {
      if (this.job.masterFlag) {
        this.btnSynchroThailandClickHandlerMaster()
      } else {
        this.btnSynchroThailandClickHandlerSlave()
      }
    },
    async btnSynchroThailandClickHandlerMaster() {
      if (this.slaveHbls.length === 0) {
        return
      }
      const currentHblNbr2 = this.thailandForm.hblNbr2
      let count = 0
      for (let i = 0; i < this.thailandCargoDocs.length; ++i) {
        const cargoDoc = this.thailandCargoDocs[i]
        if (cargoDoc.deleted) {
          continue
        }
        if (count < this.slaveHbls.length) {
          cargoDoc.afrLast = false
          await this.cloneThailandCargoDoc(cargoDoc, this.slaveHbls[count])
          const lclSlave = this.lclSlaveJobMap.get(this.slaveHbls[count].jobUuid)
          cargoDoc.jobNo = lclSlave ? lclSlave.jobNo : ''
          count += 1
        } else {
          if (cargoDoc.uuid) {
            cargoDoc.deleted = true
          } else {
            this.thailandCargoDocs.splice(i, 1)
            i = i - 1
          }
        }
      }
      if (count < this.slaveHbls.length) {
        for (; count < this.slaveHbls.length; ++count) {
          const newDoc = new SeaImCargoDoc().fillDefaultValue().getData()
          newDoc.jobUuid = this.job.uuid
          this.thailandCargoDocs.push(newDoc)
          await this.cloneThailandCargoDoc(newDoc, this.slaveHbls[count])
          const lclSlave = this.lclSlaveJobMap.get(this.slaveHbls[count].jobUuid)
          newDoc.jobNo = lclSlave ? lclSlave.jobNo : ''
        }
      }
      const rowData = this.thailandCargoDocs.filter(p => !p.deleted)
      const lastDoc = rowData[rowData.length - 1]
      lastDoc.afrLast = true
      await this.syncThailandContainer(this.slaveHbls)
      this.thailand2.rowData = rowData
      setTimeout(() => {
        const nodes = this.thailand2.gridApi.rowModel.rowsToDisplay
        for (const node of nodes) {
          if (node.data.hblNbr2 === currentHblNbr2) {
            this.thailand2.gridApi.setFocusedCell(node.rowIndex, this.thailand2.gridApi.columnController.getAllDisplayedColumns()[0])
            return
          }
        }
        this.thailand2.gridApi.setFocusedCell(0, this.thailand2.gridApi.columnController.getAllDisplayedColumns()[0])
      }, 100)
    },
    async btnSynchroThailandClickHandlerSlave() {
      const hbl = this.job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL)
      if (!hbl) {
        return
      }
      let count = 0
      for (let i = 0; i < this.thailandCargoDocs.length; ++i) {
        const cargoDoc = this.thailandCargoDocs[i]
        if (cargoDoc.deleted) {
          continue
        }
        if (count < 1) {
          cargoDoc.afrLast = true
          await this.cloneThailandCargoDoc(cargoDoc, hbl)
          cargoDoc.jobNo = this.job.jobNo
          count += 1
        } else {
          if (cargoDoc.uuid) {
            cargoDoc.deleted = true
          } else {
            this.thailandCargoDocs.splice(i, 1)
            i = i - 1
          }
        }
      }
      if (count < 1) {
        const newDoc = new SeaImCargoDoc().fillDefaultValue().getData()
        newDoc.jobUuid = this.job.uuid
        this.thailandCargoDocs.push(newDoc)
        newDoc.afrLast = true
        await this.cloneThailandCargoDoc(newDoc, hbl)
        newDoc.jobNo = this.job.jobNo
      }
      const rowData = this.thailandCargoDocs.filter(p => !p.deleted)
      await this.syncThailandContainer([hbl])
      this.thailand2.rowData = rowData
      setTimeout(() => {
        this.thailand2.gridApi.setFocusedCell(0, this.thailand2.gridApi.columnController.getAllDisplayedColumns()[0])
      }, 100)
    },
    /**
     *克隆新的Thailand cargoDoc对象
     */
    async cloneThailandCargoDoc(newDoc, seaCargoDoc) {
      newDoc.docType = CargoDocConsts.THAILAND
      // 处理反恐地址格式化
      if (!newDoc.afrAddress || newDoc.afrAddress.length === 0) {
      // 没有的话，根据去查后端加载出来AFR反恐地址
        await new SeaImCargoDoc(newDoc).getAfrAddress().then(data => {
          if (!data[0]) {
            newDoc.afrAddress = []
            const addressForm = new AfrAddress().fillDefaultValue().getData()
            addressForm.cargoDocUuid = newDoc.uuid
            newDoc.afrAddress.push(addressForm)
          }
        })
      }
      const afrAddress = newDoc.afrAddress[0]
      for (const type of ['shipper', 'consignee', 'notify']) {
        afrAddress[type + 'Line1'] = seaCargoDoc[type + 'Line1']
        let text = seaCargoDoc[type + 'Line2']
        if (text) {
          text += '\n'
        }
        text += seaCargoDoc[type + 'Line3']
        if (text) {
          text += '\n'
        }
        text += seaCargoDoc[type + 'Line4']
        if (text) {
          text += '\n'
        }
        text += seaCargoDoc[type + 'Line5']
        if (text) {
          text += '\n'
        }
        text += seaCargoDoc[type + 'Line6']
        if (text) {
          text += '\n'
        }
        text += seaCargoDoc[type + 'Line7']
        let no = 2
        for (let i = 0; i < text.length; i += 255, ++no) {
          afrAddress[type + 'Line' + no] = text.substring(i, i + 255)
        }
        for (; no < 7; ++no) {
          afrAddress[type + 'Line' + no] = ''
        }
      }
      afrAddress.consigneeCountry = 'TH'
      afrAddress.notifyCountry = 'TH'
      newDoc.hblNbr2 = seaCargoDoc.hblNbr2
      // 提单件数
      newDoc.quantity = seaCargoDoc.quantity
      // 包装
      newDoc.packing = seaCargoDoc.packing
      // 重量
      newDoc.weight = seaCargoDoc.weight
      // 体积
      newDoc.cubage = seaCargoDoc.cubage
      if (this.job.containerLoadType === 'FCL' || this.job.containerLoadType === 'BCF') {
        newDoc.containerStatus = '8'
      } else {
        newDoc.containerStatus = '9'
      }
      // 提单发货地
      if (seaCargoDoc.dispatchingPlace) {
        let dispatchingPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'englishName', seaCargoDoc.dispatchingPlace)
        if (!dispatchingPort) {
          dispatchingPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', seaCargoDoc.dispatchingPlace)
        }
        if (dispatchingPort) {
          newDoc.dispatchingPlaceCode = dispatchingPort.code
          newDoc.dispatchingPlace = dispatchingPort.code
        }
      }
      // 提单交货地
      if (seaCargoDoc.destinationPort) {
        let destinationPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'englishName', seaCargoDoc.destinationPort)
        if (!destinationPort) {
          destinationPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', seaCargoDoc.destinationPort)
        }
        if (destinationPort) {
          newDoc.destinationPortCode = destinationPort.code
          newDoc.destinationPort = destinationPort.code
        }
      }
      newDoc.remarks = seaCargoDoc.mark
      newDoc.cargoEnglishName = seaCargoDoc.cargoEnglishName
      if (this.job.cargoType === 'GC') {
        newDoc.docCargoType = '1'
      } else if (this.job.cargoType === 'DG') {
        newDoc.docCargoType = '2'
      } else if (this.job.cargoType === 'LD' || this.job.cargoType === 'RF') {
        newDoc.docCargoType = '7'
      }
      newDoc.mbl = this.job.mbl
      newDoc.vessel = this.job.vessel
      const voyage = this.job.voyageFlight
      newDoc.voyageFlight = CargoDocUtil.replaceVoyage(voyage, true)
      newDoc.vesselIMO = this.job.vesselIMO
      newDoc.vesselCode = this.job.vesselUnCode
      newDoc.eta = this.job.eta
      newDoc.etd = this.job.etd
      // 提单起运港
      newDoc.loadingPortCode = this.job.loadingPortCode
      newDoc.loadingPort = this.job.loadingPortCode
      // 提单卸货港
      newDoc.dischargingPortCode = this.job.dischargingPortCode
      newDoc.dischargingPort = this.job.dischargingPortCode
      newDoc.berthDate = this.job.eta
      newDoc.shedNumber = this.job.portDistrict
      newDoc.cargoMovement = 'O'
    },
    async syncThailandContainer(sourceCargoDoc) {
      if (this.job.masterFlag) {
        if (this.job.containers && this.job.containers.length > 0) {
          let usages = []
          for (const container of this.job.containers) {
            if (container.containerUsage && container.containerUsage.length > 0) {
              usages = usages.concat(container.containerUsage)
            }
          }
          if (usages && usages.length > 0) {
            for (const doc of this.thailandCargoDocs) {
              const curContainer = await new SeaImCargoDoc(doc).getEdiContainer()
              for (let i = curContainer.length - 1; i >= 0; --i) {
                const containerItem = curContainer[i]
                if (containerItem.uuid) {
                  containerItem.deleted = true
                } else {
                  curContainer.splice(i, 1)
                }
              }
              for (const item of usages) {
                const sourceDoc = sourceCargoDoc.find(p => p.hblNbr2 === doc.hblNbr2)
                if (sourceDoc && sourceDoc.jobUuid === item.jobUuid) {
                  const ec = new EDIContainer().fillDefaultValue().getData()
                  ec.deleted = false
                  ec.containerNo = item.containerNo
                  ec.sealNo = item.sealNo
                  ec.eqType = item.eqType
                  ec.eqSize = item.eqSize
                  ec.quantity = Number(item.quantity)
                  ec.weight = Number(item.weight)
                  ec.cubage = Number(item.cubage)
                  ec.mark = item.mark
                  ec.cargoName = item.cargoName
                  ec.containerUsageUuid = null
                  ec.hsCodeContainer = this.thailandForm.hsCode
                  ec.goodsCargoType = doc.docCargoType
                  ec.containerStatus = doc.containerStatus
                  ec.cargoDocUuid = doc.uuid
                  curContainer.push(ec)
                }
              }
            }
          }
        }
      } else {
        if (this.job.containerUsages && this.job.containerUsages.length > 0) {
          for (const doc of this.thailandCargoDocs) {
            const curContainer = await new SeaImCargoDoc(doc).getEdiContainer()
            for (let i = curContainer.length - 1; i >= 0; --i) {
              const containerItem = curContainer[i]
              if (containerItem.uuid) {
                containerItem.deleted = true
              } else {
                curContainer.splice(i, 1)
              }
            }
            for (const item of this.job.containerUsages) {
              const sourceDoc = sourceCargoDoc.find(p => p.hblNbr2 === doc.hblNbr2)
              if (sourceDoc && sourceDoc.jobUuid === item.jobUuid) {
                const ec = new EDIContainer().fillDefaultValue().getData()
                ec.deleted = false
                ec.containerNo = item.containerNo
                ec.sealNo = item.sealNo
                ec.eqType = item.eqType
                ec.eqSize = item.eqSize
                ec.quantity = Number(item.quantity)
                ec.weight = Number(item.weight)
                ec.cubage = Number(item.cubage)
                ec.mark = item.mark
                ec.cargoName = item.cargoName
                ec.containerUsageUuid = null
                ec.hsCodeContainer = this.thailandForm.hsCode
                ec.goodsCargoType = doc.docCargoType
                ec.containerStatus = doc.containerStatus
                ec.cargoDocUuid = doc.uuid
                curContainer.push(ec)
              }
            }
          }
        }
      }
    },
    async existThailandContainerUsage(u, doc) {
      const containerList = await new SeaImCargoDoc(doc).getEdiContainer()
      const container = this.job.masterFlag ? u : u.container
      for (const item of containerList) {
        if (!item.deleted && container.eqSize === item.eqSize && container.eqType === item.eqType &&
          container.containerNo === item.containerNo && container.sealNo === item.sealNo) {
          item.hsCodeContainer = doc.hsCode
          return true
        }
      }
      return false
    },
    onRemoveThailandCargoDoc() {
      const row = this.thailand2.selectedNode ? this.thailand2.selectedNode.data : null
      if (row) {
        this.$confirm(
          this.$t('Message.AreYouSureYouWantToDelete1') + row.hblNbr2 + this.$t('Message.AreYouSureYouWantToDelete2'),
          this.$t('Message.ConfirmDelete'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }
        ).then(async() => {
          await this.onRemoveThailandConfirmed(row)
        }).catch(() => { })
      } else {
        this.$message.info(this.$t('Message.PleaseSelectTheHBLNO'))
      }
    },
    async onRemoveThailandConfirmed(row) {
      // 查找对应cargoDoc，有uuid则标记为删除，无uuid则直接删除
      const docIndex = this.thailandCargoDocs.findIndex(p => p === row)
      if (docIndex > -1) {
        const doc = this.thailandCargoDocs[docIndex]
        if (doc.uuid) {
          doc.deleted = true
        } else {
          this.thailandCargoDocs.splice(docIndex, 1)
        }
      }
      this.thailand2.rowData = this.thailandCargoDocs.filter(p => !p.deleted)
      if (this.thailand2.rowData.length > 0) {
        const afrLastCount = this.thailand2.rowData.filter(p => p.afrLast).length
        if (afrLastCount === 0) {
          const lastAfr = this.thailand2.rowData[this.thailand2.rowData.length - 1]
          lastAfr.afrLast = true
        }
        setTimeout(() => {
          this.thailand2.gridApi.setFocusedCell(0, this.thailand2.gridApi.columnController.getAllDisplayedColumns()[0])
        }, 100)
      } else {
        this.thailandForm = new SeaImCargoDoc().fillDefaultValue().getData()
        this.thailandForm.docType = CargoDocConsts.THAILAND
        this.thailandContainer.rowData = []
      }
    },
    async sendInThailand() {
      if (this.thailandCargoDocs.length === 0) {
        return
      }
      const loading = getLoading4Cxt(this)
      try {
        for (const doc of this.thailandCargoDocs) {
          await new SeaImCargoDoc(doc).getAfrAddress()
          await new SeaImCargoDoc(doc).getEdiContainer()
        }
        const { reminderContent, content } = await sendThailand(this.thailandCargoDocs, 'SI')
        this.thailandExportDialog.showReminder = !!reminderContent
        this.thailandExportDialog.reminderContent = reminderContent
        this.thailandExportDialog.content = content
        this.thailandExportDialog.visible = true
      } finally {
        loading.close()
      }
    },
    doExportThailand() {
      const data = this.thailandExportDialog.content
      const blob = new Blob([data], { type: 'text/plain' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.job.jobNo + '.xml')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style lang="scss">
  .thailand-export {
    .cargo-rich-textarea.quill-editor .ql-container .ql-editor p {
      line-height: 22px;
    }
  }
</style>
